import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Tabs } from "antd";

import LoginByCard from "./LoginByCard";
import LoginByPhone from "./LoginByPhone";

const TabPane = Tabs.TabPane;
export class Login extends Component {

  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    //403需验证登录判断
    localStorage.setItem('needSys403Warn', true);
  }
  componentDidMount() {
    const studentinfo = localStorage.getItem('studentinfo')
    if (studentinfo) {
      this.props.history.goBack()
    }
  }
  render() {
    const { fetchGetConfigurationSuccess } = this.props.common
    const operations = fetchGetConfigurationSuccess && fetchGetConfigurationSuccess.RegisterValid === 1 ? <span className="goRegister" onClick={() => this.props.history.push("/register")}>注册新用户 ></span> : null;

    return (
      <div className="common-login" >
        <div className="login-view">
          <img src={require("../../images/login_img.png")} alt="" />
          <Tabs defaultActiveKey="1" className="login-tabs" tabBarExtraContent={operations}>
            <TabPane tab="手机快捷登录" key="1">
              <LoginByPhone {...this.props} />
            </TabPane>
            <TabPane tab="密码登录" key="2">
              <LoginByCard {...this.props} />
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/features/common/Login.js